/**
 * Solange geladen wird, keinen Leerzustand zeigen.
 * Ein leeres Array während isLoading ist noch kein Ergebnis.
 */
export function viewWhileLoading(
  loading: boolean,
  isEmpty: boolean,
): "loading" | "empty" | "ready" {
  if (loading) return "loading";
  if (isEmpty) return "empty";
  return "ready";
}
